import { ShowErrorWay } from "./utils.js";

export class CalculatorInterface {
    constructor() {
        this.debug = false;
        this._fieldTypes = [];
        this.inputFields = [];
        this.outputFields = [];
        this.forceOutputs = [];
        this.fieldGroups = [];
        this.showErrorWay = ShowErrorWay.SHOW_ALL;
        this.resetButtons = [];
        this._exportObject = {};
        this._exportObjectFinal = {};
        this.calculateForValidOnly = true;
        this.resetValuesOnIgnore = false;
        this._submitOnChange = false;
        this.isActive = true;
        this._dynamicFields = [];
        this._inputFieldsTree = {fields: []};
        this.view = "";
        this.irregularValueNames = [];
        this.lastValuesString = "";
    }

    code() { return "three_letter_code_of_calculator"; }  // reimplement it in inherited classes
    type() { return "code_for_export"; }  // reimplement it in inherited classes

    autoKey() { return '0'; }  // used for calculator with tabs (every tab - one mini calculator)
    initialize() { }  // use this instead of redefining constructor
    calculate(params) { }  // calculation method (all calculations of calculator should be here)
    beforeSubmit() { }  // before parsing
    afterSubmit() { }  // at the end of submit
    afterParse(sender, autoValidation) { }
    beforeRender() { }
    onReset() { }
    afterFirstPhaseCheck() { }
    isReady() { return true; }
    log(...args) {}
    setupHandlers() {}
    setHash(hash){}
    checkHash(hash) {}
    getHash() {}

    autoSubmit(sender, skipValueChangesCheck) {
        sender = sender || null;
        this.submitForm(sender, false, skipValueChangesCheck);
    }
    fetchFields(htmlNode) {}

    autoAddFields() {}  // adds fields from special html attributes
    loadDescription(feedbackBottom = true) {}  // just loads description from file
    patchFieldTypes(newFieldTypes) {}  // updates field-type library

    showResults() {$('.calc-div-results').addClass('show-results');}  // shows result
    hideResults() {}  // hides result

    generateExportObject() { return this._exportObject; }
    get defaultFilled(){ return false; }
    setupStatistic(params) {}  // setups statistic module
    sendStatisticMessage(string_or_object) {}  // sends statistic message to YM
    submitOnClick(selectorOrElem) {}  // turn on submitting on elem click
    submitOnChange() {}  // make submit on change

    addResetButton(selector, hideOnDefault) {}

    genUniqueId() { return Math.random() * 1e7 | 0; }

    writePath(obj, path, value, gentle=false) {}  // method for writing propery into this object using path (used to generate input values for calculation stage)
    removePathId(path) {}  // remove path
    clearPath(obj, path) {}  // clears path
    isPathInside(path, srcPath) {}  // checks if path inside
    
    addInputField(selector, name, params) {}
    addDynamicField(name, params){}
    addGroup(nameOrNames, checker, options) {}
    
    processGroup(group, sender, autoValidation) { }   // Parses group with internal checks (between elements inside group)

    parse(sender, autoValidation) { }  // Parses all input fields and initialises connected variables
    resetInputFields(params) {}
    
    addOutputField(selector, name, params, forced = false) {}

    render() {}

    forceRender() {}

    toggleCustomClasses() {}

    renderError() {}

    /**
     * Submits form
     * - calls beforeSubmit (if it returns false, stops)
     * - parse
     * - toggling reset buttons
     * - Is_Started stat send
     * - calls isReady (if false, breaks, but almost always should be true)
     * - if parse result is valid:
     *     - toggle custom classes
     *     - call calculate
     *     - if calculation is not valid, hides result part, otherwise 
     *       call beforeRender, then render, then generateExportObject, then shows results
     * - renders error for invalid parsing result
     * - calls afterSubmit
     */
    submitForm(sender, autoValidation, skipValueChangesCheck = false) {}    
    autoValidate(sender) {}    
}